module.exports = __webpack_public_path__ + "media/exports/required/assets/img/images/playstoreImage-06a4ce9bd9a9cc1f4c38b50d95ffb613.png";